// SWIPER
import Swiper, {
  EffectFade,
  Autoplay,
} from "swiper";
Swiper.use([EffectFade, Autoplay]);
// import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";



const swipers = document.querySelectorAll(".swiper");
swipers.forEach((swiperEl, index) => {
  let swiper = new Swiper(swiperEl, {
      // Optional parameters
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      autoplay: {
        delay: 500,
       },
      speed: 3000,
      disableOnInteraction: false
  });
});